module.exports = __webpack_public_path__ + "img/banner7.98bb97a1.jpg";